import {
  Box,
  Button,
  Flex,
  Stack,
  Text,
  useColorModeValue as mode,
} from '@chakra-ui/react'
import * as React from 'react'
import { PricingCard } from './PricingCard'
import { MdChat } from "react-icons/md"

export const Pricing = (
  {
    name,
    price,
    duration,
    link,
    features,
    pricestroke
  }
) => {
  const chatWithUs = () => {
    window.$crisp.push(['do', 'chat:open']);
  }

  return (
    <Box>
      <a id="pricing" />
      <Box as="section" py={{ base: '5.5em', md: '4em', lg: '4em' }}>
        <Box maxW={{ base: 'xl', md: '4xl' }} mx="auto" px={{ base: '6', md: '8' }}>
          <Flex
            direction={{ base: 'column', lg: 'row' }}
            maxW={{ base: '560px', lg: '560px' }}
            mx="auto"
            mt="10"
            bg={mode('white', 'gray.700')}
            rounded="3xl"
            boxShadow="lg"
          >
            <Box
              w={{ base: 'unset', lg: '1px' }}
              minH="0"
              h={{ base: '1px', lg: 'unset' }}
              bg={mode('gray.100', 'gray.600')}
            />
            <PricingCard
              flex="1"
              colorScheme="blue"
              name={name}
              description=""
              price={`${price}€`}
              discount="3 seats left"
              pricestroke={pricestroke}
              duration={duration}
              extras=""
              features={features}
              link={link}
            />
          </Flex>
          <Box
            mt="16"
            px="12"
            py="10"
            bg={mode('white', 'gray.700')}
            rounded="3xl"
            boxShadow="lg"
          >
            <Flex align="center" direction={{ base: 'column', md: 'row' }}>
              <Stack w="full" align="center" direction="row" spacing="8">
                <Box maxW="400px">
                  <Text fontSize="xl" fontWeight="bold">
                    Drop us a line
                  </Text>
                  <Text mt="2">
                    We'd be happy to answer your questions, and check together if the program is a good fit for you.
                  </Text>
                </Box>
              </Stack>
              <Button
                colorScheme="blue"
                size="lg"
                mt={{ base: '6', md: '0' }}
                w={{ base: 'full', md: 'auto' }}
                minW="10rem"
                flexShrink={0}
                fontSize="md"
                rightIcon={<MdChat />}
                onClick={() => chatWithUs()}
                key="lg"
              >
                Chat with us
              </Button>
            </Flex>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}